function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39 39"
}, props), React.createElement("circle", {
  cx: "19.444",
  cy: "19.444",
  r: "19.444",
  fill: "#2991B4"
}), React.createElement("path", {
  d: "M29.17 14.043L16.207 27.006l-5.941-5.942 1.523-1.523 4.418 4.407 11.44-11.428 1.523 1.523z",
  fill: "#fff"
})));